import {FieldRadio} from "./template";

export default FieldRadio;
